<app-validation-warning-dialog
    [failed]="failedCount"
    [total]="jobIds.length"
    [isOpen]="isValidationModalOpen"
    (confirm)="onProceed()"
></app-validation-warning-dialog>
<ui-dialog
    size="small"
    [open]="isWarningModalOpen"
    header="Confirm Employer Account"
    (closing)="isWarningModalOpen = false"
>
    <p>
        If you change your employer account, Indeed jobs integrated with your current account in Humi will be removed.
        Are you sure you want to continue?
    </p>
    <ui-dialog-footer>
        <ui-button type="ghost" (click)="isWarningModalOpen = false">Cancel</ui-button>
        <ui-button type="primary" (click)="confirmed = true; onSave()">Confirm</ui-button>
    </ui-dialog-footer>
</ui-dialog>
<div class="ui basic segment" [class.loading]="isLoading || isSaving">
    <app-header title="Indeed Integration Settings" [back]="true"></app-header>
    <app-job-posting-card [(isIndeedJobSyncEnabled)]="isIndeedJobSyncEnabled"></app-job-posting-card>
    @if (isIndeedJobSyncEnabled) {
        <div class="ui segment" *ngIf="!isLoading && showEmployerSelect">
            <app-segment-header title="Select Employer Account"></app-segment-header>
            <p>
                Link one of the following Indeed company accounts to Humi. If your company has an Indeed account but is
                not below, please contact the owner of the account and get added as a user.
            </p>
            <div class="app-grid">
                <mat-form-field class="columns-4">
                    <mat-label appRemoveAriaOwns>Employer Account</mat-label>
                    <mat-select
                        placeholder="Select Employer Account"
                        name="employer"
                        required
                        [(ngModel)]="integrationIndeed.employerNumber"
                    >
                        <mat-option [value]="employer.employerNumber" *ngFor="let employer of employers">{{
                            employer.company
                        }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="app-grid">
                <div class="app-grid">
                    <mat-checkbox
                        [(ngModel)]="integrationIndeed.syncJobs"
                        name="sync"
                        type="checkbox"
                        class="columns-6 small-columns-12"
                    >
                        Post all active jobs to Indeed when integration is complete
                    </mat-checkbox>
                </div>
            </div>
        </div>
        <app-quick-apply-card [(integrationIndeed)]="integrationIndeed"></app-quick-apply-card>
    }
    <div class="flex width-full justify-end">
        <ui-button type="primary" (click)="onSave()" [disabled]="!canSave"
            >Save <mat-icon svgIcon="chevronRight"></mat-icon
        ></ui-button>
    </div>
</div>
